export enum RequestQualityControlStatus {
  NoErrors = 1, // Заявка без ошибок
  HasErrors = 2, // Имеются ошибки
  HasCriticalErrors = 3, // Имеются критические ошибки
  AllProblemsSolved = 4, // Все проблемы решены
  ErrorsPartiallySolved = 5, // Ошибки исправлены частично
  NotChecked = 0, // (не ноль, а null) Заявка не проверена
}
